export const isUnitDisabled = (unit, accountClanId) => (
    (!unit.is_open && unit.clan && unit.clan.id !== accountClanId) || unit.is_destroyed
)



// WEBPACK FOOTER //
// ./containers/BattleRooms/components/UnitsList/helpers.js